var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowFirst = function SvgArrowFirst(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m94.606 32.523-72.009 68.199 70.48 66.745-5.518 5.837-76.627-72.582 78.156-74.027 5.518 5.828zM107.059 100.723l70.48 66.745-5.518 5.837-76.627-72.582 78.156-74.027 5.518 5.828-72.009 68.199z"
  })));
};
export default SvgArrowFirst;